import { ShieldCheck, History, Users } from "lucide-react";
import { Reveal, Kicker } from "@/components/landing/shared";

const FEATURES = [
  {
    i: ShieldCheck,
    t: "Nothing ships unscanned",
    b: "Every submission runs through a heuristic + LLM safety scan before an admin can approve it — no exceptions, no path around the gate.",
  },
  {
    i: History,
    t: "Versioned & audited",
    b: "Every publish, approval, rejection, and yank is an immutable, attributed event. Roll back or pull a bad version instantly.",
  },
  {
    i: Users,
    t: "RBAC that matches your team",
    b: "Owner, admin, member roles. Remove a teammate and their access — and every API key they held — dies instantly.",
  },
];

export const GovernanceFeatures = () => (
  <section className="py-16 lg:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <Kicker><ShieldCheck className="h-3.5 w-3.5" /> The governance layer</Kicker>
        <h2 className="rb-display text-3xl font-semibold tracking-tight text-[color:var(--rb-text)]">Scan gate, approval workflow, full audit trail</h2>
        <p className="mt-2 max-w-2xl text-[color:var(--rb-text-dim)]">The paid delta over "a shared git repo of skills": nothing reaches an engineer's machine without clearing your team's bar.</p>
      </Reveal>
      <div data-testid="landing-governance-features" className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        {FEATURES.map(({ i: Icon, t, b }, idx) => (
          <Reveal key={t} delay={idx * 0.06}>
            <div className="h-full rounded-2xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] p-5">
              <Icon className="h-5 w-5 text-[color:var(--rb-accent)]" />
              <h3 className="rb-display mt-3 text-base font-semibold text-[color:var(--rb-text)]">{t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[color:var(--rb-text-dim)]">{b}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
